import {CompanyPage} from 'app/pages/Company/CompanyPage'
import {HomePage} from 'app/pages/Home/HomePage'
import {isMarketplaceHostname} from 'app/utils/homePath'

/**
 * Renderiza a página raiz de acordo com o subdomínio:
 *  - marketplace (`app.atacante.com.br`)         → lista de parceiros
 *  - subdomínio de branch (`<slug>.atacante...`) → página da branch
 */
const RootRoute = () => (isMarketplaceHostname() ? <HomePage /> : <CompanyPage />)

export {RootRoute}
